
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.68771 12.2503C7.32929 12.2503 5.41676 9.48356 5.41676 7.12514V6.27095C5.41676 3.91253 7.32929 2 9.68771 2C12.0461 2 13.9587 3.91253 13.9587 6.27095V7.12514C13.9587 9.48356 12.0461 12.2503 9.68771 12.2503ZM12.2503 19.0838C12.2503 17.2849 13.0481 15.6756 14.3055 14.5797C13.0225 14.2431 11.4285 13.9587 9.68771 13.9587C7.27548 13.9587 5.13573 14.5036 3.73059 14.9777C2.69189 15.3288 2 16.3068 2 17.4028V20.7922H12.5014C12.34 20.2506 12.2503 19.6775 12.2503 19.0838ZM13.605 19.0838L16.5212 22.0001L22 16.5213L20.7922 15.3135L16.5212 19.5844L14.8128 17.876L13.605 19.0838Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowUserauthorizationFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
